// @ts-nocheck
if (!customElements.get('drawer-tabs')) {
  customElements.define('drawer-tabs', class DrawerTabs extends HTMLElement {
    #isDown = false;
    #startX = 0;
    #scrollLeft = 0;
    #hasDragged = false;

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.drawer-tab'));
      this.buttons = Array.from(this.querySelectorAll('[data-drawer-button-index]'));
      this.scrollContainer = this.querySelector('.drawer-tab-buttons');

      if (!this.tabs.length) return;

      // Set tab names on buttons from data-tab-name
      this.tabs.forEach((tab, index) => {
        tab.dataset.tabIndex = index + 1;

        const button = this.buttons[index];
        if (button) {
          button.textContent = tab.dataset.tabName || `Tab ${index + 1}`;
        }
      });

      // Remove empty tabs and their buttons
      this.tabs = this.tabs.filter((tab, index) => {
        const isEmpty = tab.innerHTML.trim() === '' || tab.children.length === 0;
        if (isEmpty) {
          this.buttons[index]?.remove();
          tab.remove();
          return false;
        }
        return true;
      });

      // Re-index buttons and tabs after removal so indices are in sync
      this.buttons = Array.from(this.querySelectorAll('[data-drawer-button-index]'));

      this.tabs.forEach((tab, index) => {
        tab.dataset.tabIndex = index + 1;
      });

      this.buttons.forEach((button, index) => {
        button.dataset.drawerButtonIndex = index + 1;
      });

      // Remove tab buttons wrapper if only 1 tab
      if (this.tabs.length <= 1) {
        this.querySelector('.drawer-tab-buttons')?.remove();
        this.scrollContainer = null;
      }

      // Get active tab index from data attribute, default to 1
      const requestedIndex = parseInt(this.dataset.activeTab) || 1;
      const tabExists = this.tabs.some(tab => parseInt(tab.dataset.tabIndex) === requestedIndex);
      const activeIndex = tabExists ? requestedIndex : 1;

      this.#setActive(activeIndex);

      // Add click listeners
      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          if (this.#hasDragged) return;
          this.#setActive(parseInt(button.dataset.drawerButtonIndex));
        });
      });

      // Drag to scroll
      if (this.scrollContainer && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.scrollContainer.addEventListener('mousedown', this.#onMouseDown);
        window.addEventListener('mousemove', this.#onMouseMove);
        window.addEventListener('mouseup', this.#onMouseUp);
        this.scrollContainer.addEventListener('click', this.#onClick, true);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('mousemove', this.#onMouseMove);
      window.removeEventListener('mouseup', this.#onMouseUp);
    }

    #setActive(index) {
      this.tabs.forEach(tab => {
        tab.hidden = parseInt(tab.dataset.tabIndex) !== index;
      });

      this.buttons.forEach(button => {
        button.classList.toggle('active', parseInt(button.dataset.drawerButtonIndex) === index);
      });
    }

    setActive(index) {
      this.#setActive(index);
    }

    #onMouseDown = (e) => {
      this.#isDown = true;
      this.#hasDragged = false;
      this.#startX = e.clientX;
      this.#scrollLeft = this.scrollContainer.scrollLeft;
      this.scrollContainer.classList.add('dragging');
    };

    #onMouseMove = (e) => {
      if (!this.#isDown) return;
      const walk = e.clientX - this.#startX;
      if (Math.abs(walk) > 5) this.#hasDragged = true;
      this.scrollContainer.scrollLeft = this.#scrollLeft - walk;
    };

    #onMouseUp = () => {
      this.#isDown = false;
      this.scrollContainer.classList.remove('dragging');
    };

    #onClick = (e) => {
      if (this.#hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
  });
}